import React from "react";
import type { SiteContent } from "../types/content";

// Re-export all types from the canonical location
export type {
  ReviewItem,
  HeroContent,
  GalleryItem,
  GalleryPromo,
  GalleryContent,
  AboutContent,
  ReviewsContent,
  ContactContent,
  TeamMember,
  TeamContent,
  WhyItem,
  WhyChooseUsContent,
  CarouselMediaType,
  CarouselItem,
  SocialItem,
  LegalContent,
  MobileQuickContactContent,
  SiteContent,
} from "../types/content";

const EMPTY_SITE_CONTENT: SiteContent = {
  brand: "Touch Event",
  logo: "/assets/site_logo.png",
  nav: ["בית", "אודות", "השירותים שלנו", "למה אנחנו", "הצוות", "גלריה", "ביקורות", "צור קשר"],
  social: [
    { name: "WhatsApp", url: "https://wa.link/b70ctm", icon: "whatsapp", ariaLabel: "Contact us on WhatsApp", color: "#25D366" },
    { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61579012019244&locale=he_IL", icon: "facebook", ariaLabel: "Visit our Facebook page", color: "#1877F2" },
    { name: "Instagram", url: "https://www.instagram.com/touch_event5?igsh=MWZjZjcwNDdzdWhwZg==", icon: "instagram", ariaLabel: "Follow us on Instagram", color: "#E4405F" },
    { name: "LinkedIn", url: "https://www.linkedin.com/company/touchevent-therapies/", icon: "linkedin", ariaLabel: "Connect with us on LinkedIn", color: "#0A66C2" }
  ],
  hero: {
    title: "TOUCH EVENT",
    subtitle: "טיפול בקליק עד אליכם למשרד",
    tagline: "מגע · רוגע · אנרגיה",
    cta: "",
    ctaEnabled: false,
    video: "/assets/background_video.mp4",
    videoMobile: "",
    videoPoster: ""
  },
  gallery: {
    title: "Gallery",
    productsPageTitle: "השירותים שלנו",
    productsPageSubtitle: "מגוון טיפולים מקצועיים המותאמים אישית לצרכי הארגון והעובדים שלכם",
    productsPageCta: "צור קשר לפרטים נוספים",
    productsPageBackText: "חזרה לדף הבית",
    images: [],
    items: [
      { image: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/gallery/eb4d0f73-ebd9-45db-8f55-d65f8190622a-whatsapp2025-11-05151113_2ddf2edf.jpg", title: "אלקטרותרפיה", description: "טכניקה המבוססת על הורדת כאב", order: 1 },
      { image: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/gallery/9b0eacba-67ad-4f5f-a418-e3ed101f9b91-5454545.jpg", title: "עיסוי שוודי/קלאסי", description: "עיסוי מרגיע ומפחית מתחים", order: 2 },
      { image: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/gallery/1b6c3443-5fb8-41f0-9e9f-a0cf093d6482-6.jpg", title: "כוסות רוח", description: "טכניקה המבוססת על הזרמת דם", order: 3 },
      { image: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/gallery/5ea6bc2c-6526-4b88-b33e-1199cc3df52a-whatsapp2025-09-15145407_987e932c.jpg", title: "עיסוי משולב", description: "שילוב טכניקות מותאם אישית", order: 4 },
      { image: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/gallery/e8a0aadb-4831-43cc-b9d3-25c3b136ca75-whatsapp2025-11-01093855_4b65812e.jpg", title: "רפלקסולוגיה", description: "טיפול בכפות הרגליים", order: 5 }
    ],
    promo: {
      title: "חווית טיפול ייחודית לכל עובד",
      body: "בואו להעלות את הרווחה של צוות העובדים במשרד",
      cta: "קבעו פגישה",
      href: "#contact"
    },
    promoPosition: 2,
    viewAllPackagesText: "צפה בכל השירותים שלנו"
  },
  about: {
    title: "טאצ' לאירועים - עיסוי חברות מקצועי",
    body: "** אנחנו מביאים טיפול מקצועי עד לאירוע שלכם: **\nעיסוי רפואי, שחרור שרירים וטכניקות מגע המותאמות לסוג האירוע \nולפרופיל המשתתפים.\nאנו מקימים פינת טיפול נעימה ושקטה, עם פרטיות, היגיינה מלאה וציוד תקני.\nהצוות עובר לפי פרוטוקולים ברורים, כולל תשאול קצר \nוהכוונה אישית לכל מטופל.\n\n**המטרה שלנו פשוטה: **\nלאפשר לאנשים לעצור לרגע, לנשום, לשחרר עומסים, ולחזור לפעילות \nממוקדים ורגועים יותר.\nכמה דקות של טיפול איכותי מפחיתות עומס בשרירים, \nמרככות כאב, מרגיעות את הראש ומעלות חיוך.\nכך כנס, יום גיבוש או חגיגת חברה–  הופכים לחוויה שנשארת בזיכרון, ומורגשת בגוף ובנפש הרבה אחרי שהאירוע מסתיים.\nמתאים לארגונים בכל קנה מידה.",
    image: "/assets/about_us.png"
  },
  team: {
    title: "המטפלים שלנו",
    members: [
      {
        key: "yona",
        name: "יהונתן טפליצקי",
        role: "ספורטתרפיסט ומטפל במגע רפואי",
        photo: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/team/41b9d647-45b7-40b5-8987-1141ab11ac74-img_9217.JPG",
        bio: "אני יהונתן טפליצקי, ספורטתרפיסט ומטפל במגע רפואי, בוגר תואר בספורטתרפיה בקריה האקדמית אונו. בעל ניסיון בעבודה קלינית בפיזיותרפיה ובטיפול במאות מטופלים – ספורטאים, מתאמנים ואנשים המתמודדים עם עומסים וכאבים שונים. הרקע שלי כספורטאי בנבחרת ישראל בג׳ודו העניק לי הבנה עמוקה של הגוף, העומסים שהוא חווה והדרך הנכונה לשחרר מתחים ולהחזיר לגוף תפקוד וחיוניות.\n\n",
        label: ""
      },
      {
        key: "dekel",
        name: "דקל מנצורה",
        role: "ספורטתרפיסט ומטפל במגע רפואי",
        photo: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/team/089584fb-d224-4d58-9d58-3d804dca1fef-whatsapp2025-11-06131703_20e7a6e8.jpg",
        photoPosition: "53% 27%",
        bio: "אני דקל מנצורה, ספורטתרפיסט מוסמך ובעל תואר מדעי בספורטתרפיה בקריה האקדמית אונו. את דרכי התחלתי מתוך אהבה עמוקה לעולם הבריאות, והיום אני עוסק בעבודה קלינית במכון פיזיותרפיה. ההתמחות שלי היא שיקום שלד־שריר וחזרה לתפקוד מיטבי עם דגש לאורך חיים בריא.\n\n",
        label: ""
      }
    ],
    quotesTitle: "",
    quotes: ["לאחר מאות מטופלים תוך שילוב טכניקות עדכניות, טיפולים מנואלים ותרגול מותאם אישית הבנו כמה כוח יש לטיפול. הרצון להעניק חוויה עם ערך אמיתי – הובילו אותנו להקים את \"טאצ' לאירועים\", המיזם נולד מתוך תשוקה לשלב בין עולם הבריאות והטיפול היישר אליכם, להעניק חוויה אישית שתהיה מהנה, מרגשת, מעצימה פיזית ומנטלית שלא תשכחו."]
  },
  why: {
    title: "למה לבחור בנו",
    subtitle: "",
    items: [
      { id: "productivity", title: "הגברת פרודוקטיביות ושיפור ביצועים", body: "עיסויים בזמן האירוע תורמים להפחתת מתחים ולשיפור זרימת הדם, מה שמוביל לעלייה באנרגיה, ריכוז ומוטיבציה בקרב העובדים", icon: "/assets/whyus/rocket.png" },
      { id: "wellbeing", title: "שיפור הבריאות והרווחה של העובדים", body: "עיסויים מקצועיים במתחם האירוע מסייעים להפחתת עומסים, להקלת כאבים ולהטמעת תרבות ארגונית חיובית של דאגה לרווחת העובד", icon: "/assets/whyus/healthy.png" },
      { id: "simple", title: "פתרון מקצועי, מהיר ונוח לכל ארגון", body: "אנחנו מגיעים לאירועים עם הצוות והציוד המלא, התאמה מלאה לקצב האירוע ולסוג העובדים – חוויה איכותית ללא מאמץ מצדכם", icon: "/assets/whyus/diagram.png" }
    ]
  },
  carousel: [
    { src: "/assets/slider/back_massage.jpg", alt: "טיפול גב" },
    { src: "/assets/slider/gallery3.png", alt: "טיפול צוואר" },
    { src: "/assets/slider/dekel and yona.jpg", alt: "דקל ויונה" },
    { src: "/assets/slider/gallery2.png", alt: "שחרור כף יד" }
  ],
  carouselTitle: "גלריה",
  carouselDescription: "הצצה לאווירה שאנחנו מייצרים באירועים ובמתחמי העיסוי שלנו. גללו וצפו בחוויות שהלקוחות שלכם יכולים לחוות בקרוב.",
  reviews: {
    title: "ביקורות",
    subtitle: "מה הלקוחות שלנו אומרים עלינו",
    items: [
      { name: "אלכס גורבצ'וב", role: "בעלים של מוקד מכירות", quote: "חיפשתי מתנת חג לעובדים ולא רציתי עוד דברים בנאלים.\nזה היה מדהים הפתיע את כל הצוות ובנוסף להכל חזרו לעבודה חדים יותר עם אנרגיות מחודשות \nתודה על הכל ! ", avatar: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/reviews/6ecf5348-fe41-4e66-ac0e-239dafb9f991-whatsapp2025-11-06140252_f5023d9a.jpg", rating: 5 },
      { name: "רוני", role: "סמנכ\"לית מכללת איק\"ום", quote: "תודה על הכל!! \nהחברה באורות אין עליכם!! מקצוענים ברמות ", avatar: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/reviews/b4f3714c-62b7-4cd2-9cc8-b032467e2f02-481434245_3472698239692822_1389365618203886390_n.jpg", rating: 5 },
      { name: "הילה", role: "מנהלת רווחת עובדים בחברת סטורי", quote: " היה מדהיםםםם\nזה היה חלק בלתי נפרד מהאירוע \nכל התגובות היו וואוווו ", avatar: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/reviews/8339f83d-3afb-458a-bd8b-c0959a041ba5-564908695_18542170258020940_9040034310007299879_n.jpg", rating: 5 },
      { name: "דנה", role: "מנהלת הפקה אלו יוגה", quote: "העמדה הייתה מושלמת , \nאווירה רגועה ,מטפלים מקצוענים ופשוט הפידבקים של אחרי האירוע היו שווים כל רגע \nבטוחה שיפגש שוב בעתיד , ממליצה בחום לכולם!! ", avatar: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/reviews/f7815259-2d8a-441e-991c-9bc35c9912f6-209762055_203125225022224_559505502104898616_n.jpg", rating: 5 },
      { name: "ליעד", role: "בעלת סטודיו ליוגה", quote: ".הייתם מעולים ומקסימים, אין לי ספק שעוד נפגש", avatar: "https://avrzzxxamjiiewzqboib.supabase.co/storage/v1/object/public/media/reviews/51080de5-cd0d-4834-898b-e06c21813ebf-582078396_17847517266603461_4017127855231991986_n.jpg", rating: 5 }
    ]
  },
  contact: {
    email: "yd.massage.events@gmail.com",
    title: "צור קשר",
    subtitle: "יש לכם שאלה או רוצים שנתכנן ביחד את האירוע הבא שלכם? השאירו הודעה ונחזור אליכם.",
    address: "אזור המרכז",
    hours: "א'-ה' 08:00-18:00\nו' 08:00-15:00",
    phone: "058-4276667",
    image: "/assets/contact.jpg",
    formTitle: "השאירו פרטים לשיחת ייעוץ ללא עלות",
    formLabels: {
      areaLabel: "אזור פעילות:",
      hoursLabel: "שעות פעילות:",
      phoneLabel: "טלפון:",
      emailLabel: "מייל:",
      namePlaceholder: "שם מלא",
      emailPlaceholder: "אימייל",
      phonePlaceholder: "טלפון",
      messagePlaceholder: "איך נוכל לעזור?",
      submitButton: "שליחה",
      submittingButton: "שולח...",
      validationError: "אנא מלאו את כל שדות הטופס.",
      successMessage: "תודה! קיבלנו את ההודעה ונחזור אליכם בהקדם.",
      errorMessage: "אירעה שגיאה בשליחת ההודעה. נסו שוב או צרו קשר במייל.",
      validationEmailRequired: "כתובת אימייל נדרשת",
      validationEmailInvalid: "פורמט אימייל לא תקין",
      validationEmailTooLong: "כתובת אימייל ארוכה מדי (מקסימום 255 תווים)",
      validationPhoneRequired: "מספר טלפון נדרש",
      validationPhoneInvalid: "מספר טלפון לא תקין",
      validationPhoneTooShort: "מספר טלפון קצר מדי (מינימום 7 ספרות)",
      validationPhoneTooLong: "מספר טלפון ארוך מדי (מקסימום 15 ספרות)",
      validationNameRequired: "שם נדרש",
      validationNameInvalid: "שם לא תקין",
      validationNameTooLong: "שם ארוך מדי (מקסימום 100 תווים)",
      validationMessageRequired: "הודעה נדרשת",
      validationMessageInvalid: "הודעה לא תקינה",
      validationMessageTooLong: "הודעה ארוכה מדי (מקסימום 2000 תווים)",
      validationRateLimit: "יותר מדי שליחות. אנא נסו שוב בעוד {minutes} דקות.",
      rateLimitMaxSubmissions: 3,
      rateLimitTimeWindow: 15
    }
  },
  ui: {
    footer: {
      copyright: "All rights reserved",
      backToTop: "Back to top ↑"
    },
    loading: {
      loadingLabel: "טוען",
      loadingImages: "טוען תמונות...",
      loadingMessages: "טוען הודעות...",
      noMessages: "עדיין אין הודעות מהטופס."
    }
  },
  promoModal: {
    enabled: false,
    title: "מבצעים",
    subtitle: "הצטרפו אלינו עכשיו",
    description: "קבלו הנחה מיוחדת על כל החבילות שלנו",
    buttonText: "לבירור",
    buttonLink: "#contact",
    discountBadge: "-10%",
    showOnFirstVisit: false,
    showDelay: 1000
  },
  legal: {
    privacyTitle: "מדיניות פרטיות",
    privacyText: "אנו מכבדים את פרטיותך ומחויבים להגן על המידע שלך.\n\nהמידע משמש ליצירת קשר ותיאום שירותים בלבד. אנו לא מעבירים מידע לצדדים שלישיים.",
    termsTitle: "תנאי שימוש",
    termsText: "השימוש באתר מותנה בהסכמתך לתנאים אלה.\n\nכל התכנים באתר שייכים ל-Touch Event ומוגנים בזכויות יוצרים.\n\nהמידע באתר מוצג \"כמות שהוא\". השימוש באחריותך.",
    accessibilityTitle: "הצהרת נגישות",
    accessibilityText: "Touch Event מחויבת להנגשת האתר לאנשים עם מוגבלויות.\n\nנתקלתם בבעיה? נשמח לעזור.",
    lastUpdated: "ינואר 2026",
    footerLabel: "מידע משפטי:"
  },
  mobileQuickContact: {
    callButtonText: "התקשרו עכשיו",
    whatsappButtonText: "שלחו הודעה ב-WhatsApp",
    contactFormButtonText: "השאירו פרטים ונחזור אליכם",
    quickNavLabel: "ניווט מהיר"
  }
};

export const defaultContent: SiteContent = EMPTY_SITE_CONTENT;

export interface UsePersistentContentResult {
  content: SiteContent;
  setContent: React.Dispatch<React.SetStateAction<SiteContent>>;
  reset: () => void;
}
